import React from "react";
import { Button, HStack, Spacer, VStack } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Redactor } from "components";
import {
  deserialize,
  serialize,
  useAuth,
  useInitializeOfflineData
} from "duck";
import { useUpdateOrganizationSettingMutation } from "requests";

interface TextProps {
  disclaimerText: string;
  organizationSettingId: number;
}

const Text: React.FC<TextProps> = ({
  disclaimerText,
  organizationSettingId
}) => {
  const parsed = new DOMParser().parseFromString(disclaimerText, "text/html");
  const initialValue = JSON.stringify(deserialize(parsed.body));

  const [value, setValue] = React.useState(initialValue);
  const [editorKey, setEditorKey] = React.useState(0);
  const [editable, setEditable] = React.useState(false);

  const [update, { loading }] = useUpdateOrganizationSettingMutation();
  const { loadDisclaimers } = useInitializeOfflineData();
  const [{ user }] = useAuth();

  return (
    <VStack align="left" spacing={4}>
      <HStack spacing={4}>
        <Spacer />
        {editable ? (
          <>
            <Button
              variant="outline"
              colorScheme="gray"
              onClick={() => {
                setEditable(!editable);
                setValue(initialValue);
                setEditorKey(key => key + 1);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                const serialized = serialize({
                  type: "",
                  children: JSON.parse(value)
                });
                update({
                  variables: {
                    input: {
                      _id: organizationSettingId,
                      disclaimerText: serialized
                    }
                  }
                }).then(() => {
                  setEditable(!editable);
                  loadDisclaimers(user.organization?._id || 0);
                });
              }}
              isLoading={loading}
            >
              Save
            </Button>
          </>
        ) : (
          <Button
            onClick={() => {
              setEditable(!editable);
            }}
            leftIcon={<BiEditAlt />}
            colorScheme="minor"
          >
            Edit
          </Button>
        )}
      </HStack>
      <Redactor
        key={editorKey}
        value={value}
        {...(editable ? { onChange: v => setValue(v) } : { readOnly: true })}
      />
    </VStack>
  );
};

export default Text;
